import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FaTimes, FaBars, FaHeart, FaGraduationCap, FaHeartbeat, FaLeaf } from 'react-icons/fa'

export default function LandingPage() {
    const [menuOpen, setMenuOpen] = useState(false)
    const navigate = useNavigate()

    return (
        <div className='min-h-screen bg-white'>

            {/* ================= HEADER ================= */}
            <header className="fixed top-0 left-0 right-0 bg-[#191c24] z-50 shadow-md">
                <div className="max-w-full mx-auto px-4 py-2 flex justify-between items-center">

                    {/* Logo + Name */}
                    <div className="flex items-center gap-3 text-white">

                        <img
                            src={require('../images/Logo.jpg')}
                            alt="Aurevia Charitable Trust Logo"
                            className="w-12 h-12 object-contain rounded"
                        />

                        <h1 className="text-xl font-bold 3xl:text-lg 2xl:text-base">
                            Aurevia Charitable Trust
                        </h1>

                    </div>

                    {/* Desktop Navigation */}
                    <nav className="flex 4xl:hidden gap-5 text-white items-center">

                        <Link
                            href="#home"
                            className="no-underline text-white"
                        >
                            Home
                        </Link>

                        <Link
                            href="#about-us"
                            className="no-underline text-white"
                        >
                            About Us
                        </Link>

                        <Link
                            href="#contact-us"
                            className="no-underline text-white"
                        >
                            Contact Us
                        </Link>

                        <Link
                            href="#our-programs"
                            className="no-underline text-white"
                        >
                            Our Programs
                        </Link>

                        <Link
                            to="/donation"
                            className="no-underline text-white"
                        >
                            Donate
                        </Link>

                        <Link
                            to="/login"
                            className="no-underline text-white"
                        >
                            Login
                        </Link>

                    </nav>

                    {/* Mobile Menu Button */}
                    <button
                        type="button"
                        className="hidden 4xl:flex text-2xl text-white"
                        onClick={() => setMenuOpen((prev) => !prev)}
                    >
                        {menuOpen ? <FaTimes /> : <FaBars />}
                    </button>

                </div>

                {/* Mobile Navigation */}
                {menuOpen && (
                    <div className="hidden 4xl:block absolute top-full right-0 w-64 bg-[#191c24] border-l border-slate-600 shadow-lg">

                        <nav className="flex flex-col py-3">

                            <Link
                                href="#home"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Home
                            </Link>

                            <Link
                                href="#about-us"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                About Us
                            </Link>

                            <Link
                                href="#contact-us"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Contact Us
                            </Link>

                            <Link
                                href="#our-programs"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Our Programs
                            </Link>

                            <Link
                                to="/donation"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Donate
                            </Link>

                            <Link
                                to="/login"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Login
                            </Link>
                        </nav>
                    </div>
                )}
            </header>


            {/* ================= HERO ================= */}
            <section
                id='home'
                className='pt-32 pb-20 px-4 text-center font-serif '
            >
                <div className='max-w-6xl mx-auto'>

                    <h2 className='text-3xl sm:text-4xl md:text-5xl font-extrabold mb-5'>
                        Aurevia Charitable Trust
                    </h2>

                    <p className='text-xl md:text-2xl font-semibold mb-5 text-slate-700'>
                        Serving Humanity, Creating Hope
                    </p>

                    <p className='text-base md:text-lg max-w-3xl mx-auto mb-8 text-slate-600 leading-7'>
                        We are committed to supporting individuals and communities
                        through meaningful initiatives in healthcare, education,
                        livelihood development and environmental sustainability.
                    </p>

                    <div className='flex flex-row 2xl:flex-row 4xl:flex-col justify-center gap-4'>

                        <button
                            onClick={() => navigate('/login')}
                            className='bg-blue-600 text-white px-7 py-3 rounded-full font-semibold hover:bg-blue-700 hover:shadow-lg'
                        >
                            Get Started
                        </button>

                        <button
                            onClick={() => navigate('/donation')}
                            className='border-2 border-blue-600 text-blue-600 px-7 py-3 rounded-full font-semibold hover:bg-blue-600 hover:text-white hover:shadow-lg transition duration-300'
                        >
                            Support Our Cause
                        </button>

                    </div>
                </div>
            </section>


            {/* ================= ABOUT US ================= */}
            <section
                id='about-us'
                className='py-16 px-4 bg-white font-serif'
            >
                <div className='max-w-6xl mx-auto'>

                    <div className='text-center mb-10'>
                        <h3 className='font-bold text-3xl mb-4'>
                            About Us
                        </h3>

                        <div className='w-16 h-1 bg-blue-600 mx-auto rounded-full'></div>
                    </div>

                    <div className='max-w-4xl mx-auto text-center space-y-5 text-slate-600 leading-7'>

                        <p>
                            Aurevia Charitable Trust is dedicated to creating positive
                            and lasting change in the lives of individuals and
                            communities. We believe that every person deserves
                            dignity, opportunity and access to essential support.
                        </p>

                        <p>
                            Through carefully planned initiatives and community
                            partnerships, we work towards building a more inclusive,
                            compassionate and sustainable society where everyone has
                            an opportunity to grow and thrive.
                        </p>

                    </div>

                </div>
            </section>


            {/* ================= MISSION & VISION ================= */}
            <section className='py-16 px-4 bg-slate-50 font-serif'>

                <div className='text-center mb-10'>
                    <h3 className='text-3xl font-bold text-slate-900 mb-4'>
                        Mission & Vision
                    </h3>
                    <div className='w-16 h-1 bg-blue-600 mx-auto rounded-full'></div>
                </div>

                <div className='grid grid-cols-2 4xl:grid-cols-1 gap-8 max-w-6xl mx-auto'>

                    {/* Mission */}
                    <div className='bg-white p-7 rounded-2xl shadow-md border border-slate-100 hover:shadow-xl'>

                        <h3 className='text-xl font-bold mb-3'>
                            Our Mission
                        </h3>

                        <p className='text-slate-600 leading-7'>
                            To empower individuals and communities by providing
                            meaningful support, creating opportunities and implementing
                            initiatives that improve quality of life and promote
                            social well-being.
                        </p>

                    </div>


                    {/* Vision */}
                    <div className='bg-white p-7 rounded-2xl shadow-md border border-slate-100 hover:shadow-xl'>

                        <h3 className='text-xl font-bold mb-3'>
                            Our Vision
                        </h3>

                        <p className='text-slate-600 leading-7'>
                            To build a compassionate and sustainable society where
                            every individual has access to opportunities, resources
                            and support needed to live a dignified and fulfilling life.
                        </p>

                    </div>

                </div>
            </section>


            {/* ================= OUR ACTIVITIES ================= */}
            <section
                id='our-programs'
                className='py-16 px-4 bg-white font-serif'
            >

                <div className='text-center mb-10'>
                    <h2 className='text-3xl font-bold mb-4'>
                        Our Activities
                    </h2>

                    <div className='w-16 h-1 bg-blue-600 mx-auto rounded-full'></div>

                </div>

                <div className='grid grid-cols-2 4xl:grid-cols-1 gap-8 max-w-6xl mx-auto px-2'>

                    {/* Health */}
                    <div className='bg-slate-50 p-7 rounded-2xl shadow-md border border-slate-100 hover:-translate-y-1 hover:shadow-xl transition duration-300'>
                        <h3 className='text-xl font-bold mb-3'>
                            Health & Well-being
                        </h3>

                        <p className='text-slate-600 leading-7'>
                            Supporting communities through healthcare initiatives,
                            awareness programs and assistance for individuals who
                            need access to essential health services.
                        </p>

                    </div>


                    {/* Education */}
                    <div className='bg-slate-50 p-7 rounded-2xl shadow-md border border-slate-100 '>

                        <h3 className='text-xl font-bold mb-3'>
                            Education
                        </h3>

                        <p className='text-slate-600 leading-7'>
                            Promoting education and learning opportunities for
                            children and individuals by supporting access to knowledge,
                            resources and skill development.
                        </p>

                    </div>


                    {/* Livelihood */}
                    <div className='bg-slate-50 p-7 rounded-2xl shadow-md border border-slate-100'>
                        <h3 className='text-xl font-bold mb-3 text-slate-900'>
                            Livelihood Development
                        </h3>

                        <p className='text-slate-600 leading-7'>
                            Creating opportunities that help individuals develop
                            skills, improve their livelihoods and work towards
                            greater financial independence.
                        </p>

                    </div>


                    {/* Climate */}
                    <div className='bg-slate-50 p-7 rounded-2xl shadow-md border border-slate-100'>

                        <h3 className='text-xl font-bold mb-3'>
                            Climate Resilience
                        </h3>

                        <p className='text-slate-600 leading-7'>
                            Encouraging sustainable practices and supporting
                            communities in building resilience against environmental
                            challenges and climate-related risks.
                        </p>

                    </div>

                </div>
            </section>

            {/* ================= FOOTER ================= */}
            <footer className='bg-[#111318] text-slate-400 py-6 px-4'>

                <div className='max-w-7xl mx-auto text-center'>

                    <p className='text-sm'>
                        © {new Date().getFullYear()} Aurevia Charitable Trust.
                        All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    )
}

